import { render, staticRenderFns } from "./PartServices.vue?vue&type=template&id=20f4a680&scoped=true"
import script from "./PartServices.vue?vue&type=script&lang=js"
export * from "./PartServices.vue?vue&type=script&lang=js"
import style0 from "./PartServices.vue?vue&type=style&index=0&id=20f4a680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f4a680",
  null
  
)

export default component.exports